import { Fragment } from 'react';

import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { NsList } from 'components/common/ns-list/NsList';
import { NsCta } from 'components/common/ns-cta/NsCta';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';
import { HELP_CONTACT_NUMBER } from 'config/app-config';
import { useDDSavingsAmount } from 'hooks/useDDSavingsAmount';

export const directDebitPromotionExpanderTestId =
  'directDebitPromotionExpanderDDTestId';

type DirectDebitPromotionExpanderProps = {
  shouldShow?: boolean;
};

export const DirectDebitPromotionExpander = ({
  shouldShow = true
}: DirectDebitPromotionExpanderProps) => {
  const { savingsAmount, priceCapDate } = useDDSavingsAmount();

  if (!shouldShow) {
    return null;
  }

  return (
    <NsExpander
      testId={directDebitPromotionExpanderTestId}
      heading="Prefer to pay without a Direct Debit?"
    >
      <p>
        <strong>A Direct Debit plan can give you lots of benefits:</strong>
      </p>
      <NsList className="ul-ticked">
        {[
          <Fragment key={0}>
            Access to our best prices. With lower gas and electricity unit rates
            if you pay by Direct Debit, you could{' '}
            <strong>save {savingsAmount} per year </strong>
            in comparison to paying when you get your bill.{' '}
            <NsCaveatLink>
              Direct Debit saving based on a dual fuel customer with an average
              consumption of 11,500 kWh for gas and 2,700 kWh for single-rate
              electricity at {priceCapDate} energy price cap rates.
            </NsCaveatLink>
          </Fragment>,
          <Fragment key={1}>
            Spread costs across the whole year and avoid more expensive winter
            payments.
          </Fragment>,
          <Fragment key={2}>
            Pick the date you would like to pay your Direct Debit - choose
            between the 1st and 28th.
          </Fragment>,
          <Fragment key={3}>
            Track and manage your Direct Debit from your online account. We can
            adjust it if you&apos;re paying too much.
          </Fragment>,
          <Fragment key={4}>
            Automatic and regular payments means your bill is always paid on
            time.
          </Fragment>,
          <Fragment key={5}>
            A worry-free way to pay that saves you time and hassle.
          </Fragment>
        ]}
      </NsList>
      <p>
        If you want to pay for your energy without a Direct Debit (paying when
        you get the bill) give us a quick call and we&rsquo;ll be happy to
        provide you a new quote over the phone. Lines open 9am-5pm
        Monday-Friday.{' '}
        <NsCaveatLink>
          We&apos;re open Monday-Friday, 9am-5pm. We may record calls to help
          improve our service to you.
        </NsCaveatLink>
      </p>
      <NsCta type="text" href={`tel:${HELP_CONTACT_NUMBER.GENERAL}`}>
        Call us on {HELP_CONTACT_NUMBER.GENERAL_LABEL}
      </NsCta>
    </NsExpander>
  );
};
